module.exports = global["$"] = require("-!D:\\AppDevops\\Dinet.Vitz.Web\\node_modules\\expose-loader\\index.js?jQuery!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?$!./~/expose-loader?jQuery!./~/jquery/dist/jquery.js-exposed
// module id = 394
// module chunks = 0